import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectCurrentProduct } from '../../../layouts/MainLayout/slice/selectors';
import { knowledgeBaseActions } from '../slice';
import {
  selectKnowledgeBaseError,
  selectKnowledgeBaseIsCustomSyncing,
  selectKnowledgeBaseIsLoading,
  selectKnowledgeBaseIsSyncingBlogs,
  selectKnowledgeBaseItems,
  selectKnowledgeBaseTotal,
} from '../slice/selectors';
import { PRODUCTS } from '../../../layouts/MainLayout/slice/constants';

export function useKnowledgeBaseList() {
  const dispatch = useDispatch();
  const items = useSelector(selectKnowledgeBaseItems);
  const total = useSelector(selectKnowledgeBaseTotal);
  const isLoading = useSelector(selectKnowledgeBaseIsLoading);
  const error = useSelector(selectKnowledgeBaseError);
  const isSyncingBlogs = useSelector(selectKnowledgeBaseIsSyncingBlogs);
  const isCustomSyncing = useSelector(selectKnowledgeBaseIsCustomSyncing);
  const currentProduct = useSelector(selectCurrentProduct);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const requestIfNeeded = React.useCallback(() => {
    dispatch(
      knowledgeBaseActions.fetchKnowledgeBaseRequested({
        productId: currentProduct ?? null,
        page: pageIndex + 1,
        limit: rowsPerPage,
        skip: pageIndex * rowsPerPage,
      }),
    );
  }, [currentProduct, dispatch, pageIndex, rowsPerPage]);

  const reload = React.useCallback(() => {
    dispatch(
      knowledgeBaseActions.fetchKnowledgeBaseRequested({
        productId: currentProduct ?? null,
        page: pageIndex + 1,
        limit: rowsPerPage,
        skip: pageIndex * rowsPerPage,
        force: true,
      }),
    );
  }, [currentProduct, dispatch, pageIndex, rowsPerPage]);

  const syncBlogs = React.useCallback(() => {
    if (currentProduct === PRODUCTS.QRTIGER) {
    dispatch(
      knowledgeBaseActions.syncBlogsRequested({
        productId: currentProduct ?? null,
      }),
    )};
  }, [currentProduct, dispatch]);

  const customSync = React.useCallback(() => {
    dispatch(
      knowledgeBaseActions.customSyncRequested({
        productId: currentProduct ?? null,
      }),
    );
  }, [currentProduct, dispatch]);

  React.useEffect(() => {
    requestIfNeeded();
  }, [requestIfNeeded]);

  return {
    items,
    total,
    isLoading,
    error,
    pageIndex,
    setPageIndex,
    rowsPerPage,
    setRowsPerPage,
    currentProduct,
    reload,
    syncBlogs,
    customSync,
    isSyncingBlogs,
    isCustomSyncing,
  };
}
